// The demand tests' waitlist (docs/plans/PIVOT_RESEARCH.md).
//
// Same rule as the newsletter (#343): the browser holds no key and talks only
// to our worker, which writes to our own database. No third party sees an
// address. The two counters (page view, price click) carry no identifier, no
// cookie and no IP - a number per day, so there is nothing to consent to.
import { NEWSLETTER_API_BASE_URL } from './NewsletterService';

const post = (path, body) =>
  fetch(`${NEWSLETTER_API_BASE_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });

const WaitlistService = {
  isValidEmail(email) {
    return (
      typeof email === 'string' &&
      email.length <= 254 &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())
    );
  },

  /** Fire and forget: a counter must never break the page. */
  track(test, event) {
    post('/waitlist/event', { test, event }).catch(() => {});
  },

  async join({ test, email, answers, priceClick, locale }) {
    if (!this.isValidEmail(email)) throw new Error('invalid_email');
    let res;
    try {
      res = await post('/waitlist', { test, email: email.trim(), answers, priceClick, locale });
    } catch {
      throw new Error('network');
    }
    if (!res.ok) throw new Error(res.status === 429 ? 'rate_limited' : 'server');
    return true;
  },
};

export default WaitlistService;
